/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CopyDocumentResponseData,
  CopyDocumentResponseDataFromJSON,
  CopyDocumentResponseDataFromJSONTyped,
  CopyDocumentResponseDataToJSON
} from './CopyDocumentResponseData'

/**
 *
 * @export
 * @interface UpdateDocumentCtaImageResponse
 */
export interface UpdateDocumentCtaImageResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateDocumentCtaImageResponse
   */
  status?: number
  /**
   *
   * @type {CopyDocumentResponseData}
   * @memberof UpdateDocumentCtaImageResponse
   */
  data?: CopyDocumentResponseData
}

export function UpdateDocumentCtaImageResponseFromJSON(json: any): UpdateDocumentCtaImageResponse {
  return UpdateDocumentCtaImageResponseFromJSONTyped(json, false)
}

export function UpdateDocumentCtaImageResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDocumentCtaImageResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CopyDocumentResponseDataFromJSON(json['data'])
  }
}

export function UpdateDocumentCtaImageResponseToJSON(value?: UpdateDocumentCtaImageResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CopyDocumentResponseDataToJSON(value.data)
  }
}
